import React, { useState, useEffect, useRef } from 'react';
import {
  Popover,
  Menu,
  Form,
  Input,
  Table,
  Card,
  Button,
  Row,
  Col,
  message,
  Checkbox,
  Popconfirm,
  Collapse,
  Modal,
} from 'antd';
import hide from '../../assets/images/hide.png';
import show from '../../assets/images/show.png';
import ball from '../../assets/images/ball.png';
import { useHistory } from 'react-router';
import './index.css';
import api from '../../api';
import { useDataState, useTable } from '../../hooks';
import moment from 'moment';
import { useForm } from 'antd/es/form/Form';
import { DownOutlined } from '@ant-design/icons';
import { getShowHandicapScore } from '../../constants/handicap';
import HandicapBillCard from '../../components/StepBillCard/HandicapBillCard';
import StepBillCard from '../../components/StepBillCard/StepBillCard';
const { Panel } = Collapse;

function HandicapPage() {
  const history = useHistory();
  const username = localStorage.getItem('username');
  const [selectedMatch, setSelectedMatch] = useState();
  const [loading, setLoading] = useState();
  const [showStep, setShowStep] = useState();
  const [value, setValue] = useState();
  const [form] = useForm();
  const [confirmModalOpen, setConfirmModalOpen] = useState();
  const [showMenu, setShowMenu] = useState(true);
  const inputRef = useRef(null);

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const userData = useDataState();
  const billData = useDataState();
  const stepBillData = useDataState();

  // const { table }
  const { Column, ColumnGroup } = Table;
  const { tableProps } = useTable(() => {
    return api.user.getHandicapList({
      date: moment(),
    });
  }, [loading]);

  useEffect(() => {
    const promise = api.user.getUserDetail(username);
    userData.load(Promise.resolve(promise).then((value) => value));
  }, [loading]);

  useEffect(() => {
    const promise = api.user.getHandicapBill({ username });
    billData.load(Promise.resolve(promise).then((value) => value));
  }, [loading]);

  useEffect(() => {
    const promise = api.user.getStepBill({ username });
    stepBillData.load(Promise.resolve(promise).then((value) => value));
  }, [loading]);

  const tabledata = tableProps?.dataSource?.data;
  const bill = billData?.data?.data;
  const stepBill = stepBillData?.data?.data;
  const user = userData?.data?.data;
  const maxBetValue = user?.handicap_max_bet

  function getItem(label, key, icon, path, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
      path,
    };
  }
  function getPath(key) {
    const list = ['/handicap', '/step'];
    return list[key];
  }

  const onSelectMenu = (index) => {
    history.push(getPath(index));
  };

  const items = [
    getItem('แสดงเมนูกีฬา', 'sub1', '', '', [
      getItem(
        'ฟุตบอล',
        'g1',
        '',
        '',
        [
          getItem('ราคาต่อรอง', '0', '', '/handicap'),
          getItem('มิกซ์ พาร์เลย์', '1', '', '/step'),
        ],
        'group'
      ),
    ]),
  ];

  const onCancel = () => {
    closeConfirmModal();
    setSelectedMatch();
    setValue();
    form.setFieldValue('bet_credits', '');
  };

  const showConfirmModal = () => {
    setConfirmModalOpen(true);
  };

  const closeConfirmModal = () => {
    setConfirmModalOpen(false);
  };

  const onBet = async () => {
    setLoading(true);
    // let text = 'เดิมพันยืนยัน?';
    // if (window.confirm(text) == true) {
    const payload = {
      ...selectedMatch,
      username: username,
      bet_credits: value,
    };
    if (selectedMatch.is_open != true && user?.isSpecial != true && user?.isNew != true) {
      message.error('คู่นี้มีผู้เดิมพันจำนวนมาก กรุณาลองใหม่อีกครั้ง');
    } else {
      await api.user
        .betHandicap(payload)
        .then((res) => {
          message.success('ทำรายการสำเร็จ');
          closeConfirmModal();
          onCancel();
          window.location.reload();
        })
        .catch((err) => {
          if (err.response.status === 501) {
            message.error(`เดิมพัน ${user.bill_per_day} บิล/วัน`);
          } else if (err.response.status === 502) {
            message.error(
              'มีคู่บอลบางคู่มีผู้เดิมพันจำนวนมาก กรุณาลองใหม่อีกครั้ง'
            );
          } else if (err.response.status === 400) {
            message.error('เครดิตไม่เพียงพอ');
          } else message.error('เกิดข้อผิดพลาด');
        });
    }
    setLoading(false);
    // } else {
    // }
  };

  const isSelectedTeamHandicap =
    selectedMatch?.selectedTeam === selectedMatch?.handicap_team;

  const confirmModal = (
    <Modal
      open={confirmModalOpen}
      onClose={closeConfirmModal}
      onCancel={closeConfirmModal}
      style={{ fontFamily: 'Kanit' }}
      footer={null}
    >
      <div style={{ fontSize: '20px' }}>เดิมพันยืนยัน?</div>
      <Form
        initialValues={{
          remember: true,
        }}
        onFinish={onBet}
        layout='vertical'
        style={{ fontFamily: 'Kanit' }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Form.Item>
            <Button onClick={closeConfirmModal}>ยกเลิก</Button>
          </Form.Item>
          <Form.Item>
            <Button
              type='primary'
              htmlType='submit'
              disabled={loading}
              style={{ background: '#F7D249', color: 'black' }}
            >
              ยืนยัน
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );

  return (
    <div className='container'>
      {confirmModal}
      <Row style={{ height: '100%' }}>
        <Col span={5} style={{ padding: '10px', background: '#7886c7' }}>
          {!selectedMatch && (
            <div>
              <table>
                <tr>
                  {showMenu ?
                    <div className='PanelShowMenuBg' onClick={() => setShowMenu(false)}>
                      <img width={20} src={hide} />
                      <div>
                        ซ่อนเมนูกีฬา
                      </div>
                    </div> :
                    <div className='PanelShowMenuBg' onClick={() => setShowMenu(true)}>
                      <img width={16} src={show} />
                      <div>แสดงเมนูกีฬา</div>
                    </div>}
                </tr>
                {showMenu && <>
                  <tr>
                    <div className='menu'>
                      <img width={20} src={ball} />
                      ฟุตบอล
                    </div>
                    <a className='menu-list' onClick={() => onSelectMenu(0)}>
                      ราคาต่อรอง
                    </a>
                    <a className='menu-list' onClick={() => onSelectMenu(1)}>
                      มิกซ์ พาร์เลย์
                    </a>
                  </tr>
                </>}
              </table>

              <table>
                <tr>
                  <div className='PanelShowMenuBg' style={{ marginTop: '5px' }} onClick={() => setShowMenu(true)}>
                    <img width={16} src={show} />
                    <div>รอ และ ยกเลิก</div>
                  </div>
                </tr>
                <tr>
                  <div style={{ backgroundColor: '#e9f3fd', paddingBottom: '5px' }}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '10px',
                        paddingTop: '10px'
                      }}
                    >
                      <Button
                        style={{
                          width: '45%',
                          height: '25px',
                          fontSize: '11px',
                          background:
                            'linear-gradient(to bottom, #FAFAFA, #DEDEDE)',
                        }}
                      >
                        ที่รอ
                      </Button>
                      <Button
                        style={{
                          width: '45%',
                          height: '25px',
                          fontSize: '11px',
                          background:
                            'linear-gradient(to bottom, #FAFAFA, #DEDEDE)',
                        }}
                      >
                        โมฆะ
                      </Button>
                    </div>
                    {bill && bill.map((item) => {
                      return <HandicapBillCard bill={item} />
                    })}
                    {stepBill && stepBill.map((item) => {
                      return <StepBillCard stepBill={item} />
                    })}
                  </div>
                </tr>
              </table>
            </div>
          )}
          {selectedMatch && (
            <Card style={{ background: '#e0e4f0', borderRadius: '0px' }}>
              <div style={{ fontWeight: 'bold' }}>ฟุตบอล / แต้มต่อ</div>
              <Card
                style={{ border: '1px solid #8c8c8c', borderRadius: '0px' }}
              >
                <div
                  style={{
                    color: isSelectedTeamHandicap ? '#B50000' : 'black',
                    textAlign: 'center',
                    fontWeight: 'bold',
                  }}
                >
                  {`${selectedMatch?.selectedTeam}`}
                </div>
                <div
                  style={{
                    textAlign: 'center',
                    fontWeight: 'bold',
                    color: ' #606060',
                  }}
                >
                  {`แฮนดิแคป ${isSelectedTeamHandicap ? '-' : ''}${selectedMatch?.handicap_score
                    }`}
                </div>
              </Card>
              <div
                style={{
                  textAlign: 'center',
                  marginTop: '20px',
                  marginBottom: '20px',
                }}
              >
                <div>{selectedMatch?.team_a}</div>
                <div>-vs-</div>
                <div>{selectedMatch?.team_b}</div>
              </div>

              <Form
                initialValues={{
                  remember: true,
                }}
                onFinish={showConfirmModal}
                style={{ fontFamily: 'Kanit' }}
                form={form}
              >
                <Form.Item
                  label='จำนวนเงิน : '
                  name='bet_credits'
                  rules={[
                    { required: true, message: 'กรุณากรอกจำนวนเงิน' },
                    {
                      validator: (rule, value) => {
                        if (user?.isSpecial) {
                          return Promise.resolve();
                        }
                        if (value < 10) {
                          return Promise.reject('เดิมพันขั้นต่ำ 10 บาท');
                        }
                        if (value > maxBetValue) {
                          return Promise.reject(`เดิมพันได้สูงสุด ${maxBetValue} บาท`);
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    ref={inputRef}
                    type='number'
                    onChange={(e) => setValue(e.target.value)}
                  ></Input>
                </Form.Item>
                <Checkbox
                  defaultChecked
                  style={{
                    fontSize: '11px',
                    background: '#C9C9D3',
                    width: '100%',
                    marginBottom: '15px',
                  }}
                >
                  ยอมรับราคาต่อรองที่ดีกว่า
                </Checkbox>
                <Row>
                  <Col span={12} style={{ padding: '1px' }}>
                    <div style={{ fontSize: '10px', background: '#C9C9D3' }}>
                      การจ่ายเงินขั้นสูงสุด :{' '}
                    </div>
                  </Col>
                  <Col
                    span={12}
                    style={{
                      fontSize: '10px',
                      padding: '1px',
                      textAlign: 'right',
                    }}
                  >
                    <div style={{ background: 'white' }}>
                      {value > maxBetValue ? maxBetValue : value}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col span={12} style={{ padding: '1px' }}>
                    <div style={{ fontSize: '10px', background: '#C9C9D3' }}>
                      เดิมพันขั้นต่ำสุด :{' '}
                    </div>
                  </Col>
                  <Col
                    span={12}
                    style={{
                      color: '#003399',
                      fontSize: '10px',
                      padding: '1px',
                      textAlign: 'right',
                    }}
                  >
                    <div style={{ background: 'white' }}>10</div>
                  </Col>
                </Row>
                <Row>
                  <Col span={12} style={{ padding: '1px' }}>
                    <div style={{ fontSize: '10px', background: '#C9C9D3' }}>
                      เดิมพันขั้นสูงสุด :
                    </div>
                  </Col>
                  <Col
                    span={12}
                    style={{
                      color: '#B50000',
                      fontSize: '10px',
                      padding: '1px',
                      textAlign: 'right',
                    }}
                  >
                    <div style={{ background: 'white' }}>{maxBetValue}</div>
                  </Col>
                </Row>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '10px',
                    height: '40px'
                  }}
                >
                  <Form.Item>
                    <Button
                      type='primary'
                      htmlType='submit'
                      style={{
                        color: 'white',
                        background: 'linear-gradient(to bottom, #87a5d9, #3a6bba)',
                        width: '100%'
                      }}
                    >
                      ทำรายการ
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button onClick={onCancel} style={{ width: '100%' }}>ยกเลิก</Button>
                  </Form.Item>
                </div>
              </Form>
            </Card>
          )}
        </Col>
        <Col
          span={19}
          style={{ background: '#e1e7ff' }}
        >
          <table style={{ border: '1px solid black', fontSize: '11px', margin: '0px', width: '100%', tableLayout: 'auto' }}>
            <thead style={{ backgroundColor: '#203061', color: '#fff' }}>
              <tr>
                <th style={{ width: '15%' }} rowSpan={2}>เวลา</th>
                <th style={{ width: '40%' }} rowSpan={2}>คู่แข่งขัน</th>
                <th style={{ width: '45%' }} colspan="4">เต็มเวลา</th>
              </tr>
              <tr>
                <th style={{ width: '80px' }}>ราคาต่อรอง</th>
                <th style={{ width: '80px' }}>ทีมเจ้าบ้าน</th>
                <th style={{ width: '80px' }}>ทีมเยือน</th>
              </tr>
            </thead>
            <tbody style={{ backgroundColor: '#e1e7ff' }}>
              {tabledata?.length > 0 && tabledata.map((row) => {
                return <tr>
                  <td style={{ width: '15%' }}>
                    <p class="bold">{moment(row.match_start_at).format('DD/MM')}</p>
                    <p class="bold">{moment(row.match_start_at).format('HH:mm')}</p>
                  </td>
                  <td style={{ width: '40%', height: '40px', verticalAlign: 'top' }}>
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', marginRight: '5px' }}>
                      <p className="bold" style={{ margin: 0, padding: 0, color: row.team_a === row.handicap_team ? '#B50000' : '', }}>{row.team_a}</p>
                      <p className="bold" style={{ margin: 0, padding: 0, color: row.team_b === row.handicap_team ? '#B50000' : '', }}>{row.team_b}</p>
                    </div>
                  </td>
                  <td style={{ width: '15%', height: '40px', verticalAlign: 'top' }}>
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-start', marginRight: '5px' }}>
                      <p className="bold" style={{ margin: 0, padding: 0 }}>{getShowHandicapScore(row.handicap_score)}</p>
                    </div>
                  </td>
                  <td style={{ width: '15%', height: '40px', verticalAlign: 'top' }}>
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-start', marginRight: '5px' }}>
                      <a
                        onClick={async () => {
                          await setSelectedMatch({ ...row, selectedTeam: row.team_a });
                          handleFocus();
                        }}
                        className="link" style={{ margin: 0, padding: 0 }}>2.00</a>
                    </div>
                  </td>
                  <td style={{ width: '15%', height: '40px', verticalAlign: 'top' }}>
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-start', marginRight: '5px' }}>
                      <a
                        onClick={async () => {
                          await setSelectedMatch({ ...row, selectedTeam: row.team_b });
                          handleFocus();
                        }}
                        className="link" style={{ margin: 0, padding: 0 }}>2.00</a>
                    </div>
                  </td>
                </tr>
              })}
            </tbody>
          </table>

        </Col>
      </Row>
    </div>
  );
}

export default HandicapPage;
